import React, { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';
import {baseUrl, baseimgUrl, userLocation, ipAddress, userName, formatDateTime} from '../Univ.js'

const VendorPayment = (props) => {
  const { dist_id } = useParams();


  const [patientData, setPatientData] = useState([]);
const currentDate = new Date();
const localDate = new Date(currentDate.getTime() - currentDate.getTimezoneOffset() * 60000);
const formattedDate = localDate.toISOString().slice(0, 10);

  const [opbillData, setopbillData] = useState([]);
  const [lnet, setLnet] = useState([]);
  const [rows, setRows] = useState([]);
  const [total, setTotal] = useState(0);
  const [subtotal, setSubTotal] = useState(0);
  const [changed, setChanged] = useState(false);

  const [pharmData,setpharmData]=useState({
    "pay_status": '',
    "pay_by": '',
    "pay_on": '',
    "pay_type": '',
    "pay_id": '',
    "pay_amount": '',
    "pay_balance": '',
    "pay_detail": '',
    "ip_add":'',
  });

  useEffect(() => {
    try {
      const status = 0;
      axios.get(`${baseUrl}grn-search/${dist_id}/${status}/`)
        .then(function (response) {

        setopbillData(response.data);
        });

    } catch (error) {
      console.log(error);
    }
  }, [dist_id]);


 useEffect(() => {
  setRows(rows);
  }, [rows]);

const handleKeyDown = (e, index) => {
  const newRows = [...rows];
  switch (e.keyCode) {
    case 18: // Alt key
      e.preventDefault();
      handleDeleteRow(e, index);
      break;
    default:
      break;
  }
};

const inputRefs = useRef([]);
  useEffect(() => {
    inputRefs.current[inputRefs.current.length - 1]?.focus();
  }, [rows.length]);

   const handleDeleteRow = (e, rowIndex) => {
      e.preventDefault();
      const newOpbillData = [...opbillData];
      newOpbillData.splice(rowIndex, 1);
      setopbillData(newOpbillData);
   };

 const handleChange = (e, index) => {
  const { name, value } = e.target;
  setpharmData(prevState => ({ ...prevState, [name]: value }));
};

const handleAmountChange = (e, subIndex) => {
  const newLnet = [...lnet];
  setLnet(newLnet);
};

useEffect(() => {
  let subTotal = 0;
  let newTotal = 0;

  subTotal = arraySum(lnet); // Calculate subTotal based on arraySum

  if (rows.length > 0) {
    let subTotal1 = 0;
    for (let i = 0; i < rows.length; i++) {
      const row = rows[i];
      subTotal1 += row.invamount;
    }
    subTotal += subTotal1; // Add subTotal1 to the existing subTotal
  }
  newTotal = subTotal;

  setSubTotal(subTotal);
  setTotal(newTotal);
}, [lnet, rows]);

const arraySum = (arr) => {
    return arr.reduce((total, value) => total + parseFloat(value), 0);
  };

useEffect(() => {
  const lnetDefaultValues = [];

  opbillData.forEach((row) => {
      const lnetDefaultValue = (row.invamount || 0);
      lnetDefaultValues.push(lnetDefaultValue);
  });

  setLnet(lnetDefaultValues);
}, [opbillData]);

   const formSubmit = (e) => {
  e.preventDefault();
  const dbType = document.getElementById('dbType').value;
  const details = document.getElementById("details").value;
  const idsFromRows = opbillData.map(row => row.id);
  const allIds = idsFromRows.join(',');

  axios.post(`${baseUrl}get_vpay_id/`)
    .then(response => {
      const pay_id = response.data.value;
      const idsArray = allIds.split(',');

      idsArray.forEach((id, index) => {
        const row = opbillData[index];
        const _formData = new FormData();

        _formData.append('pay_id', pay_id);
        _formData.append('pay_amount', row.invamount);
        _formData.append('pay_type', dbType);
        _formData.append('pay_detail', details);
        _formData.append('pay_on', formattedDate);
        _formData.append('pay_status', '1');
        _formData.append('pay_by', userName);
        _formData.append('ip_add', ipAddress);
        _formData.append('location', userLocation);

        axios.put(`${baseUrl}pay-grn/${id}/`, _formData)
          .then(response => {
            // Handle success if needed
          })
          .catch(error => {
            console.log(error);
          });
      });

      Swal.fire({
        title: 'Payment Generated.',
        icon: 'success',
        timer: 5000,
        showConfirmButton: false
      });
        setTimeout(() => {
              window.location.href = '/vendor-search/';
            }, 3000);
    })
    .catch(error => {
      console.log(error);
      Swal.fire(
        'Error!',
        'Failed to generate unique value. Please try again later.',
        'error'
      );
    });
};


  return (
  <section className="container mt-4">
  <form>
   <div className="row table-responsive">
    <div className='col-md-12 col-12 mb-2'>
      <table className="erp-table-modern">
        <thead>
        <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
          <th>Distributor ID</th>
          <th>Distributor Name</th>
        </tr>
      </thead>
      <tbody>
          <tr>
            <td style={{width:'10%'}}>{opbillData[0]?.dist.id}</td>
            <td style={{width:'10%'}}>{opbillData[0]?.dist.name}</td>
          </tr>
      </tbody>
    </table>
    </div>
   </div>
    <div className='table-responsive'>
      <table className="erp-table-modern">
        <thead>
        <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
          <th style={{width: 120}}>ID</th>
          <th style={{width: 500}} >GRN ID</th>
          <th style={{width: 500}} >Outstanding Amount</th>
        </tr>
      </thead>

      </table>
    {opbillData.map((row, index) => {
        return (
        <div key={index}>
        <input
            type="text"
            name={`id-${index}`}
            id={`id-${index}`}
            className="ms-1 me-4 mt-4"
            value={row.id}
            onChange={(e) => handleChange(e, index)}
            style={{width: 120}}
            tabIndex={-1}
            onKeyDown={(e) => handleKeyDown(e, index)}
            readOnly
          />
           <input
              type="text"
              className="ms-4 me-2"
              style={{width: 500}}
              name="grn_no"
              value={row.grn_no}
              onChange={(e) => handleChange(e, index)}
              onKeyDown={(e) => handleKeyDown(e, index)}
              tabIndex={-1}
              readOnly
            />
            <input
              type="text"
              className="ms-4 me-2"
              style={{width: 500}}
              name="invamount"
              value={row.invamount}
              onChange={(e) => handleChange(e, index)}
              onKeyDown={(e) => handleKeyDown(e, index)}
              tabIndex={-1}
              readOnly
            />
            <button  className="btn btn-danger" style={{display: 'none'}} type="button" onClick={(e) => handleDeleteRow(e, index)}>Delete</button>
        </div>
        );

    })}

  <div className="row ms-5 mt-5">
  <div className="col-md-6">
  <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}
        className='ms-5' >
    <div className="form-group">
      <label style={{ fontWeight: 'bold' }}>Subtotal: &nbsp;</label>
      <div className="input-group">
        <div className="input-group-addon me-2 ">&#8377;</div>
        <input type="number" onChange={handleChange} value={subtotal} readOnly />
      </div>
    </div>

    <div className="form-group mt-3">
      <label style={{ fontWeight: 'bold' }}>Total: &nbsp;</label>
      <div className="input-group">
        <div className="input-group-addon me-2 ">&#8377;</div>
        <input type="number" onChange={handleChange} name="tot" value={total} readOnly />
      </div>
    </div>
  </div>
  </div>
  <div className="col-md-6">
    <div className="form-group">
      <label>Choose Payment Type</label>
      <select name="dbType" id="dbType" >
        <option value="">Select Pay Mode</option>
        <option value="Cash">Cash</option>
        <option value="Cheque">Cheque</option>
        <option value="Others">Others</option>
      </select>
    </div>
    <div className="form-group">
      <label>Details:</label>
      <textarea
        className="no-comma form-control"
        tabIndex="0"
        name="details"
        id="details"
        rows={2}
        cols={2}
      ></textarea>
    </div>
  </div>
</div>
<div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}
        className='mb-5' >
          <button type="button" onClick={formSubmit}className="btn btn-primary mt-4">Submit</button>
</div>
    </div>
    </form>
  </section>
  );
};

export default VendorPayment;
